import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// Define the custom icon
const customIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  shadowSize: [41, 41]
});

export const MarkerWithPopup = ({ data }) => {
  const position = [
    parseFloat(data.latitude),
    parseFloat(data.longitude)
  ];

  if (isNaN(position[0]) || isNaN(position[1])) {
    console.error(`Invalid position for station ${data.id}:`, position);
    return null;
  }

  return (
    <Marker position={position} icon={customIcon}>
      <Popup>
        <div >
          <h3 className="text-xl font-bold mb-2 text-gray-900">{data.name}</h3>
          <p className="text-sm text-gray-700"><span className="font-semibold">ID:</span> {data.id}</p>
          <p className="text-sm text-gray-700"><span className="font-semibold">Type of Measurements:</span> {data.TypeofMeasurements}</p>
          <p className="text-sm text-gray-700"><span className="font-semibold">Location:</span> {data.location}</p>
        </div>
      </Popup>
    </Marker>
  );
};
